
function About(props) {
  return <div className="about-body">
    <h1>About</h1>
    <p>This app aims to provide a visual way to navigate using the Glen Cove Loop Bus. The positions are approximate as I do not have a way to track the bus in realtime.</p>
    <p>The latest Loop Bus schedule I could find was last updated in August, 2021: <a target="__blank" href="https://cdn.townweb.com/glencoveny.gov/wp-content/uploads/2021/08/Loop-Bus-Service-Schedule.pdf">Loop-Bus-Service-Schedule.pdf</a> </p>
    <p> <button onClick={props.goToHome}>Back To Home</button> </p>
  </div>
}
export default About;